import PropTypes from 'prop-types';
import React from 'react';
import AbstractFilteredList from 'components/core/AbstractFilteredList';
import ListItem from 'components/core/ListItem';
import Flexbox from 'flexbox-react';

export default class BadgedItemList extends AbstractFilteredList {

    static propTypes = {
        process: PropTypes.object,
        type: PropTypes.string,
        hideBadges: PropTypes.bool, // Some times we don't want to show the badges, depending upon what form we are on
        getBackgroundColor: PropTypes.func
    };

    getItemClassName() {
        return 'entity';
    }

    getListClassName() {
        return 'entity-list';
    }

    renderItem = (name, value, selected) => {
        // <span className="badged-item-label">{name}</span>
        return (
            <ListItem
                key={name}
                name={name}
                className={this.getItemClassName()}
                selected={selected}
                onClick={this.onClick}
                onDoubleClick={this.props.onDoubleClick}
            >
                <Flexbox flexDirection="row" alignItems="center">
                    <span className="badged-item" style={this.props.getBackgroundColor(this.props.type, name)}/>
                    <span className="badged-item-label">
                        {this.renderEntity(name)}
                    </span>
                </Flexbox>
            </ListItem>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/BadgedItemList.js